import React, { useEffect, useState } from 'react';
import SearchIcon from 'Assets/Icons/search.svg';
import FilterIcon from 'Assets/Icons/filter.svg';
import DownloadIcon from 'Assets/Icons/download.svg';
import DebouncedInput from './DebouncedInput';
import FilterOffIcon from 'Assets/Icons/filter_alt_off.svg';
import {
  FormSubmitButton,
  ModalFormCancelButton,
  SmartFileUploader,
} from 'Components/Form';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import { TableFileUploader } from 'Components/Form/SmartInputs/TableFileUploader';
import './styles.scss';
import { ModalDrawerButtonRow } from 'Components/Display';
import { IconButton, Menu, MenuItem } from '@mui/material';

export type TableHeaderProps = {
  headerTitle?: string;
  onChangeValue: (value: string) => void;
  onPressFilterIcon?: () => void;
  onPressDownloadIcon?: () => void;
  numberOfFiltersActive: number;
  filtersEnabled: boolean;
  headerDisabled?: boolean;
  fileUploaderEndpoint?: string;
  fileUploaderFormEndpoint?: string;
  uploadExtraProps?: { [key: string]: any };
  fileUploaderDisabledLabel?: string;
  searchKey?: string;
  customHeaderSection?: React.ReactNode;
  hideFilterIcon?: boolean;
  hideExportIcon?: boolean;
};

export const TableHeader: React.FC<TableHeaderProps> = ({
  headerTitle,
  onChangeValue,
  onPressFilterIcon,
  onPressDownloadIcon,
  numberOfFiltersActive,
  filtersEnabled,
  headerDisabled,
  fileUploaderEndpoint,
  fileUploaderDisabledLabel,
  fileUploaderFormEndpoint,
  uploadExtraProps,
  searchKey,
  customHeaderSection,
  hideFilterIcon,
  hideExportIcon,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    onPressDownloadIcon && onPressDownloadIcon();
    handleCloseMenu();
  };
  return (
    <>
      <div className="table-header">
        <div className="table-header-title-search">
          <h1>{headerTitle}</h1>

          {!headerDisabled && (
            <div className="search-container">
              <img src={SearchIcon} alt="searchIcon" />
              <DebouncedInput
                onChangeValue={(e) => onChangeValue(e.target.value)}
                placeholder="Search"
                value={searchKey}
              />
            </div>
          )}
        </div>
        <div className="table-actions">
          {fileUploaderEndpoint && (
            <>
              <TableFileUploader
                label="Files"
                required
                fileEndpoint={fileUploaderEndpoint}
                fileUploaderDisabledLabel={fileUploaderDisabledLabel}
                isEdit={false}
                withComments={false}
                allowMultiple={true}
                addOrEditEndpoint={fileUploaderFormEndpoint}
                uploadExtraProps={uploadExtraProps}
              />
            </>
          )}

          {!headerDisabled && (
            <>
              {customHeaderSection && <>{customHeaderSection}</>}
              {!hideFilterIcon && (
                <div className="filter-icon-wrapper">
                  <img
                    src={!filtersEnabled ? FilterIcon : FilterOffIcon}
                    alt="filterIcon"
                    className="filter-icon"
                    onClick={onPressFilterIcon}
                  />
                  {numberOfFiltersActive > 0 && (
                    <span className="filter-count-badge">
                      {numberOfFiltersActive}
                    </span>
                  )}
                </div>
              )}
              {!hideExportIcon && <div className="export-button-wrapper">
                <IconButton
                  onClick={handleOpenMenu}
                  aria-label="Download"
                  size="small"
                  className="download-icon-button"
                >
                  <img src={DownloadIcon} alt="downloadIcon" style={{ width: 18, height: 18 }} />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={isOpen}
                  onClose={handleCloseMenu}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem onClick={handleDownload} className="download-menu-item">
                    Download as CSV
                  </MenuItem>
                </Menu>
              </div>}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default TableHeader;
